import { Helmet } from "react-helmet-async";

const SITE = "https://1123publishing.com";
const DEFAULT_IMAGE =
  "https://customer-assets.emergentagent.com/job_6aa50ac6-6491-4cdd-ae40-783d99c83368/artifacts/z2pljbsu_FB_IMG_1780170011870.jpg";

export const Seo = ({ title, description, path = "", image = DEFAULT_IMAGE, type = "website", jsonLd }) => {
  const url = `${SITE}${path}`;
  const blocks = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {blocks.map((b) => (
        <script key={b["@type"]} type="application/ld+json">
          {JSON.stringify(b)}
        </script>
      ))}
    </Helmet>
  );
};
